<template>
  <v-card outlined elevation="0">
    <v-card-title class="text-h6 font-weight-bold">
      Upgrade Application
    </v-card-title>

    <v-card-text>
      <v-alert dense outlined type="info" class="mb-6">
        <strong
          >Provide the following additional details to be able to submit the
          application:</strong
        >
      </v-alert>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container fluid class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="form.statementOfAchievements"
                label="Statement of Achievements"
                outlined
                auto-grow
                rows="4"
                counter="400"
                :rules="rules.statementOfAchievements"
                hint="Include specific examples, programme names, mentee names, publication titles, journal names, patent titles, numbers, and years."
                persistent-hint
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="form.provenLeadership"
                label="Proven Leadership and Service"
                outlined
                auto-grow
                rows="4"
                counter="400"
                :rules="rules.provenLeadership"
                hint="Describe leadership roles and engineering-related service to society or professional bodies (maximum 400 words)."
                persistent-hint
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="form.contributionToProfession"
                label="Contribution to Engineering Knowledge and/or Practice"
                outlined
                auto-grow
                rows="4"
                counter="400"
                :rules="rules.contributionToProfession"
                hint="Describe innovations, publications, conference presentations, standards, codes, or other contributions to engineering practice (maximum 400 words)."
                persistent-hint
              />
            </v-col>

            <v-col cols="12" class="d-flex justify-end">
              <v-btn color="primary" large :disabled="!valid" @click="submit">
                Submit Application
                <v-icon right> mdi-checkbox-marked-circle </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { AuthService } from "@/modules/auth";

export default {
  name: "UpgradeForm",
  data: function () {
    return {
      form: {
        amount: 0,
        toCategory: "",
        memberNo: "",
        ProfileID: "",
        requestedDate: "",
        statementOfAchievements: "",
        provenLeadership: "",
        contributionToProfession: "",
      },
      valid: false,
    };
  },

  mounted() {
    this.$store.dispatch("Upgrade/getPlans");
  },

  computed: {
    upgrade() {
      return this.$store.getters["Upgrade/plans"][0];
    },

    user() {
      return AuthService.user;
    },

    rules() {
      return {
        statementOfAchievements: [
          (v) => !!v || "Statement of achievements is required",
        ],
        provenLeadership: [(v) => !!v || "The field is required"],
        contributionToProfession: [(v) => !!v || "The field is required"],
      };
    },
  },

  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$confirm.show({
          title: `Submit Application ?`,
          text: `By clicking submit, you confirm that you have read the terms and conditions, that you understand them and that you agree to be bound by them.`,
          rejectLabel: "Cancel",
          acceptLabel: "Submit",
          onConfirm: () => {
            this.form.amount = this.upgrade.amount;
            this.form.toCategory = this.upgrade.toCategory;
            this.form.memberNo = this.user.profile.MemberNo;
            this.form.ProfileID = this.user.profile_id;

            this.$store.dispatch("Upgrade/submitUpgrade", this.form);
          },
        });
      }
    },
  },
};
</script>
